import React from "react";
import "./Subscription.css";

const OrderConfirmationModal = ({ charges, onConfirm, onCancel, loading }) => {
  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Subscription</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              disabled={loading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="text-center mb-4">
              <h6 className="fw-bold mb-2">Premium Subscription Activation</h6>
              <p className="text-muted mb-4">
                You're about to activate premium services with a one-time
                payment.
              </p>
            </div>

            <div className="bg-light p-4 rounded-3 mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="fw-medium">One Time Charges</span>
                <span className="h5 fw-bold text-primary mb-0">₹{charges}</span>
              </div>

              <div className="border-top pt-3">
                <small className="text-muted">
                  • One-time payment, no renewal fees
                  <br />
                  • Instant activation
                  <br />• Access to all premium features
                </small>
              </div>
            </div>

            <div className="alert alert-warning mb-4" role="alert">
              <small className="d-flex align-items-start">
                <i className="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
                <span>
                  <strong>Important:</strong> This is a non-refundable
                  subscription charge. By proceeding, you agree to our terms and
                  conditions.
                </span>
              </small>
            </div>
          </div>
          <div className="modal-footer border-top-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Processing...
                </>
              ) : (
                <>
                  <i className="bi bi-credit-card me-2"></i>
                  Pay ₹{charges} Now
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationModal;
